// Open a rendered print-message PDF returned by the legacy api in a new tab.
//
// Handles both response shapes:
//   - {message_base64: "..."}  — Path A (api PR #228), required on Lambda
//   - {message_url: "https://..."}  — legacy disk-write path on EC2
//
// Pre-Path-A backends ignore the response_format=inline param and return
// message_url; post-deploy they return message_base64. Both work.

export function openPrintMessage(data) {
  if (!data) return false;

  try {
    if (data.message_base64) {
      const bytes = Uint8Array.from(atob(data.message_base64), (c) => c.charCodeAt(0));
      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const opened = window.open(url, "_blank");
      if (!opened) {
        URL.revokeObjectURL(url);
        return false;
      }
      // Revoke after a delay so the new tab has time to load the bytes.
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return true;
    }

    if (data.message_url) {
      return Boolean(window.open(data.message_url, "_blank"));
    }
  } catch (_) {
    return false;
  }

  return false;
}
